import React, {PureComponent} from "react"

import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import {TenantWalletTopup} from "@irati/types"

import {TopUpConfirmationPopup} from "../WalletPopups"

interface Props extends InjectIntl {
  tenantWalletTopup: TenantWalletTopup,
  showCompletionModal: boolean,
  goBackToTransactions(): void
}

class CardConfirmationPopUp extends PureComponent<Props> {
  render() {
    const {formatMessage, tenantWalletTopup, showCompletionModal, goBackToTransactions} = this.props
    const tenantName = authentication.userTenant().public_name
    const userEmail = authentication.user().email
    const firstRow = {
      label: formatMessage({id: "wallet.tenant.topUp.cardPopUp.amountPurchased"}),
      value: formatCurrency({
        currencyCode: authentication.defaultUserCurrency(),
        value: tenantWalletTopup.amount,
        isCents: true,
        trimZerosFromWholeNumber: false
      })
    }
    const secondRow = {
      label: formatMessage({id: "wallet.tenant.topUp.cardPopUp.order"}),
      value: tenantWalletTopup.uuid
    }
    return (
      <TopUpConfirmationPopup
        title={formatMessage({id: "wallet.tenant.topUp.cardPopUp.header"})}
        mainMessage={formatMessage({id: "wallet.tenant.topUp.cardPopUp.mainMessage"}, {tenantName})}
        invoiceToMessage={formatMessage({id: "wallet.tenant.topUp.invoicePopUp.invoiceTo"}, {userEmail})}
        firstRow={firstRow}
        secondRow={secondRow}
        details={tenantWalletTopup}
        onClose={goBackToTransactions}
        show={showCompletionModal} />
    )
  }
}

export default injectIntl(CardConfirmationPopUp)
